import React from 'react'
import { WarningIconButton } from '../../../UI/WarningIconButton/WarningIconButton'
import { putAwayActions } from '../../actions/putAwayActions'
import { putAwayActions as putAwayBussines } from '../../actions/putAwayBusiness'
import { FlipBackOptions } from '../../types/enums'

interface FlipButtonProductProblemsProps {}

export const FlipButtonProductProblems: React.FC<FlipButtonProductProblemsProps> =
  () => {
    const { handleFlipGetHistory } = putAwayActions()
    const { getElementsWithExcess } = putAwayBussines()

    const isProductsWithProblems = getElementsWithExcess().some(
      (el) => el.skuId
    )

    if (!isProductsWithProblems) return <div></div>

    return (
      <WarningIconButton
        content={getElementsWithExcess().length}
        shouldAppear={getElementsWithExcess().some((el) => el.skuId)}
        onClick={() => handleFlipGetHistory(FlipBackOptions.ProductProblems)}
      />
    )
  }
